const { InnerBlocks, RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { title, margin } = attributes;

  return (
    <section className={`TabsCompany ${margin}`} id="PlansCompany">
      <div className="Container">
        <RichText.Content
          tagName="h2"
          className="Typography title-4 center color-blue-dark margin-base"
          value={title}
        />

        <div className="TabsCompany__tabs">
          <button
            id="tabDefaultCompany"
            className="TabsCompany__link"
            onClick="openCompanyTab(event, 'pme')"
          >
            PME
          </button>

          <button
            className="TabsCompany__link"
            onClick="openCompanyTab(event, 'corporativo')"
          >
            Corporativo
          </button>
        </div>
      </div>

      <InnerBlocks.Content />
    </section>
  );
};

export default Save;
